import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { Category } from "@faire/retailer-visitor-shared/models/Category/Category";
/**
 * Builds a category model from the given category url ids and the provided category tree
 *
 * NOTE: Should only be used from the router of the category and suppliers page
 *
 * @param categoryUrlIds - url ids of the category
 * @param serializedCategories - the category tree to build the category model from
 * @returns A category chain of the category model
 */ export var fromUrlIds = function(categoryUrlIds, serializedCategories) {
    if (categoryUrlIds.length === 0) {
        return undefined;
    }
    var _categoryUrlIds = _to_array(categoryUrlIds), categoryUrlId = _categoryUrlIds[0], subcategoryUrlIds = _categoryUrlIds.slice(1);
    if (!categoryUrlId) {
        return undefined;
    }
    var matchingCategory = serializedCategories.find(function(cat) {
        var _cat_url_id;
        return ((_cat_url_id = cat.url_id) === null || _cat_url_id === void 0 ? void 0 : _cat_url_id.toLowerCase()) === categoryUrlId.toLowerCase();
    });
    var _matchingCategory_name, _ref, _matchingCategory_sub_categories, _matchingCategory_is_product_based;
    return new Category({
        name: (_ref = (_matchingCategory_name = matchingCategory === null || matchingCategory === void 0 ? void 0 : matchingCategory.name) !== null && _matchingCategory_name !== void 0 ? _matchingCategory_name : categoryUrlId) !== null && _ref !== void 0 ? _ref : "",
        urlId: {
            id: categoryUrlId
        },
        pathIdentifier: matchingCategory === null || matchingCategory === void 0 ? void 0 : matchingCategory.path_identifier,
        subCategory: fromUrlIds(subcategoryUrlIds, (_matchingCategory_sub_categories = matchingCategory === null || matchingCategory === void 0 ? void 0 : matchingCategory.sub_categories) !== null && _matchingCategory_sub_categories !== void 0 ? _matchingCategory_sub_categories : []),
        isProductFirstCategory: matchingCategory ? (_matchingCategory_is_product_based = matchingCategory.is_product_based) !== null && _matchingCategory_is_product_based !== void 0 ? _matchingCategory_is_product_based : false : undefined,
        uniqueDisplayName: matchingCategory === null || matchingCategory === void 0 ? void 0 : matchingCategory.unique_display_name
    });
};
